import React from 'react';
export var UnableSchedulePage = function () {
    return (React.createElement("div", { className: "result-cont text-center w-50 center-auto", style: { paddingTop: 120 } },
        React.createElement("div", { className: "result-cricle warning" },
            React.createElement("span", { className: "iconfont icon-close" })),
        React.createElement("h3", null, "Rescheduling work orders requires a 24-hour notice."),
        React.createElement("p", { className: "text-center" }, "Please call us if you need to reschedule this work order.")));
};
export default UnableSchedulePage;
